<template>
  <div class="container" v-bind:class="{ componenter: isHomecomponent }">
    <div class="row">
      <div class="col-12">
        <h4 class="text-center mt-5 mb-3">
          Market Data: Intelligence and Insights
        </h4>

        <div class="text-center">
          <nav
            class="navbar navbar-expand-lg navbar-light mx-auto d-block d-md-inline-block px-3"
            style="background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), #B5B2B2;"
          >
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarTogglerDemo01"
              aria-controls="navbarTogglerDemo01"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
              <!-- <a class="navbar-brand" href="#">Hidden brand</a> -->
              <ul class="navbar-nav mt-2 mt-lg-0">
                <li class="nav-item active">
                  <a class="nav-link" href="javascript:void(0)">Graph</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)">Table</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)">Commodity</a>
                </li>
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    >Location</a
                  >
                  <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="#">Country</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#">State/Province</a>
                  </div>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript:void(0)">Date</a>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link" to="/marketinsights"
                    >Insights
                  </router-link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div style="height:450px;">
      <h6 class="text-center my-3">Select Commodity Price Indices</h6>
      <line-chart
        ref="lineGraph"
        :chart-data="datacollection"
        :options="optioncollection"
      ></line-chart>
      <button @click="fillData()">Randomize</button>
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/LineChart";

export default {
  components: {
    LineChart
  },
  props: ["isComponent"],

  data() {
    return {
      datacollection: null,
      optioncollection: null,
      isHomecomponent: this.isComponent
    };
  },
  mounted() {
    this.fillData();
    this.fillOptions();
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: "Commodity Agricultural Index",
            fill: true,
            lineTension: 0.4,
            backgroundColor: "rgba(0, 175, 239,.1)",
            borderColor: "#00afef",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "#fff",
            pointBackgroundColor: "#2a2f37",
            pointBorderWidth: 2,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: "#00afef",
            pointHoverBorderColor: "#fff",
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 5,
            spanGaps: false,
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt()
            ]
          },
          {
            label: "Commodity Price Index",
            fill: true,
            lineTension: 0.4,
            backgroundColor: "rgba(255, 215, 0,.1)",
            borderColor: "gold",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "#fff",
            pointBackgroundColor: "#2a2f37",
            pointBorderWidth: 2,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: "gold",
            pointHoverBorderColor: "#fff",
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 5,
            spanGaps: false,
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt()
            ]
          },
          {
            label: "Commodity Fuel (energy) Index",
            fill: true,
            lineTension: 0.4,
            backgroundColor: "rgba(0, 128, 0,.1)",
            borderColor: "green",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "#fff",
            pointBackgroundColor: "#2a2f37",
            pointBorderWidth: 2,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: "green",
            pointHoverBorderColor: "#fff",
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 5,
            spanGaps: false,
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt()
            ]
          },
          {
            label: "Commodity Food Price Index",
            fill: true,
            lineTension: 0.4,
            backgroundColor: "rgba(255, 165, 0,.1)",
            borderColor: "orange",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "#fff",
            pointBackgroundColor: "#2a2f37",
            pointBorderWidth: 2,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: "orange",
            pointHoverBorderColor: "#fff",
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 5,
            spanGaps: false,
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt()
            ]
          },
          {
            label: "Commodity Metals Price Index",
            fill: true,
            lineTension: 0.4,
            backgroundColor: "rgba(0, 0, 255,.1)",
            borderColor: "blue",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "#fff",
            pointBackgroundColor: "#2a2f37",
            pointBorderWidth: 2,
            pointHoverRadius: 6,
            pointHoverBackgroundColor: "blue",
            pointHoverBorderColor: "#fff",
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 5,
            spanGaps: false,
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt()
            ]
          }
        ]
      };
    },

    fillOptions() {
      this.optioncollection = {
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontSize: "11",
                fontColor: "#969da5"
              },
              gridLines: {
                color: "rgba(0,0,0,0.0)",
                zeroLineColor: "rgba(0,0,0,0.0)"
              }
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true
                // max: 100
              }
            }
          ]
        }
      };
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    }
  }
};
</script>

<style scoped>
.componenter {
  margin-top: -100px !important;
}
</style>
